export default __webpack_public_path__ + "static/media/photo-camera.55ab12ad.svg";